import * as wjcGrid from '@grapecity/wijmo.grid';

export class NpFlexGridSelector2 {

    private _selectedSet: Set<any> = new Set();
    private _flexGrid: wjcGrid.FlexGrid;
    public get flexGrid() {
        return this._flexGrid;
    }

    multiSelection: boolean = false;

    constructor(flexGrid: wjcGrid.FlexGrid, multiSelection?: boolean) {
        this._flexGrid = flexGrid;
        this.multiSelection = multiSelection || false;


        // kjk 2025-04-05
        // chrome 에서 wijmogrid 에서 aria-hidden="true" 오류 메시지를 더이상 안보게 하기!!!
        // 참고로 wj-flex-grid [headersFocusability]="'All'" 적용하면 wj-part="ch" 는 해결됨.
        setTimeout(() => { this.dontSeeAreahidden(); }, 100);
    }

    dontSeeAreahidden() {
        const headerElement = this.flexGrid.hostElement.querySelectorAll('[wj-part="ch"][aria-hidden="true"]');
        const focusElement = this.flexGrid.hostElement.querySelectorAll('[wj-part="focus"][aria-hidden="true"]');
        headerElement?.forEach((el) => el.setAttribute('aria-hidden', 'false'));
        focusElement?.forEach((el) => el.setAttribute('aria-hidden', 'false'));
    }

    public _isSelected = false;
    public get isSelected() {
        return this._isSelected;
    }
    private _isSelectedAll: boolean = false;
    public get isSelectedAll() {
        return this._isSelectedAll;
    }
    private _isIndeterminate: boolean = false;
    public get isIndeterminate() {
        return this._isIndeterminate;
    }

    public get selectedRowCount() {
        return this._selectedSet.size;
    }

    chkState() {

        const selectedCnt = this._selectedSet.size;
        const rowCount = this._flexGrid.rows.filter(r => !(r instanceof wjcGrid.GroupRow)).length;
        if (selectedCnt > rowCount) {
            throw Error("selectedRowsCnt가 더 많습니다. 에러를 추적하여 해결해야 함.")
        }

        this._isSelected = selectedCnt > 0;

        if (selectedCnt < 1) {
            this._isIndeterminate = false;
            this._isSelectedAll = false;
        } else if (selectedCnt === rowCount) {
            this._isIndeterminate = false;
            this._isSelectedAll = true;
        } else {
            this._isIndeterminate = true;
            this._isSelectedAll = false;
        }
    }

    onSelectorStateChanged!: (selector: NpFlexGridSelector2) => void;
    onSelectorStateChanged2: any[] = [];

    get selectedRows(): wjcGrid.Row[] {
        if (!this.flexGrid) {
            return [];
        }
        return this.flexGrid.rows.filter(r => this._selectedSet.has(r.dataItem));
    }

    get selectedItems(): any[] {
        if (!this.flexGrid) {
            return [];
        }

        return Array.from(this._selectedSet);
    }

    isRowSelected(row: wjcGrid.Row): boolean {
        const data = row.dataItem;
        return this._selectedSet.has(data);
    }

    /**
     * 초기화
     * 
     * select 정보를 초기화 한다.
     * 기존에 selection이 존재했다면 selectionChangedEvent를 발생시킨다.
     * 
     */
    init() {
        if (this.isSelected) {
            this._doClear();
            this.chkState();
            this._onSelectionChanged();
        }
    }

    /**
     * 선택된 row가 존재하면 모두 선택을 해제 한다.
     * selector의 상태를 변경하거나 event를 발생시키지 않는다.
     * @returns 
     */
    private _doClear() {
        this._selectedSet.clear();
    }

    /**
     * 모든 select를 true로 세팅한다.
     */
    selectAll() {
        if (this.isSelectedAll !== true && this.flexGrid.rows.length > 0) {
            this.flexGrid.deferUpdate(() => {
                this.flexGrid.rows.forEach((r: wjcGrid.Row) => {
                    if (r instanceof wjcGrid.GroupRow) {
                        console.log('is grouprow');
                    } else {
                        this._selectedSet.add(r.dataItem);
                    }
                });
            })
            this.chkState();
            this._onSelectionChanged();
        }
    }

    /**
     *  현재 선택을 토글한다.
     *  부분선택 => 전체해제
     *  전체 선택 => 전체해제
     *  전체 미션택 => 전체선택
     * @param e 
     */
    toggleAll(e?: any) {
        if (this.isSelected) {
            this.init();
        } else if (this.multiSelection) {
            this.selectAll();
        } else {
            // multi 모드가 아니라면 selectAll을 하지 않고 그대로 이벤트를 종료한다.
            if (e) {
                e.preventDefault();
            }
        }
    }

    /**
     * row를 select 한다. 
     * @param row 
     */
    select(row: wjcGrid.Row, e?: MouseEvent) {

        if (e && e.ctrlKey) {
            // 콤보박스를 클릭한 경우 이벤트 중복 발생을 막기 위함
            // e.shiftKey &&
            return;
        }

        if (row instanceof wjcGrid.GroupRow) {
            return;
        }

        const data = row.dataItem;
        const current: boolean = this._selectedSet.has(data);
        if (this.multiSelection === false) {
            this._doClear();
        }

        if (current) {
            if (this._selectedSet.has(data)) {
                // 현재 선택되어 있다면 해제
                this._selectedSet.delete(data);
            }
        } else {
            // 현재 미선택이면 선택
            this._selectedSet.add(data);
        }

        this.chkState();
        this._onSelectionChanged();

    }

    public toggleRows(rows: wjcGrid.Row[]) {
        if (rows.length < 1) {
            return;
        }
        this.flexGrid.deferUpdate(() => {
            rows.forEach(r => {

                if (r instanceof wjcGrid.GroupRow) {
                    return;
                }

                if (this._selectedSet.has(r.dataItem)) {
                    this._selectedSet.delete(r.dataItem);
                } else {
                    this._selectedSet.add(r.dataItem);
                }
            });
            this.chkState()
            this._onSelectionChanged();
        })
    }

    private _onSelectionChanged() {
        if (this.onSelectorStateChanged) {
            this.onSelectorStateChanged(this);
        }

        if (this.onSelectorStateChanged2 && this.onSelectorStateChanged2.length > 0) {
            this.onSelectorStateChanged2.forEach(h => h(this))
        }
    }

    revalidateSelectedItems() {

        if (this.flexGrid.collectionView) {
            const newSet = this.flexGrid.collectionView.items.reduce((acc, item) => acc.add(item), new Set());
            for (const item of this._selectedSet) {
                if (!newSet.has(item)) {
                    this._selectedSet.delete(item);
                }
            }
            this.chkState();
        }


        // 20240528 - 그리드 연결 후 이벤트로 인해 해당 컬렉션이 변경되는 경우 실제 length가 변경되지 않은 상태로 이벤트가 발생하면 제대로 동작하지 않는 버그 해결
        // if (this._selectedSet.size > 1 && this.flexGrid.collectionView && this.flexGrid.collectionView.items.length > 1) {
        // }

    }
}